export enum EScanpoolTarget {
  REQUIREMENT = 'REQUIREMENT', PROCESS = 'PROCESS'
}
